import { GQL, KontoNumUtils } from "../index";
import { SollHaben } from "./SollHaben";
import { CompanyKontoExtMax, KontoDefaultLen } from "../models/InterfaceBase";
export class PaymentUtils {
    /**
     * In ER, ER_A, Deb - we have [many Payments to record policy], so we should unlink related payment.
     * In Bank, Kasse, FE, Pos (?) - we have [One Payment to Record strong relation], so we should remove the payment.
     * @param {ProductKey} pk
     */
    static isProductPaymentRepresentation = (pk) => {
        switch (pk) {
            case GQL.IProductKey.Bank:
            case GQL.IProductKey.Kb:
            case GQL.IProductKey.Fe:
                return true;
        }
        return false;
    };
    static isProductPaymentSource = (pk) => {
        switch (pk) {
            case GQL.IProductKey.Er:
            case GQL.IProductKey.ErA:
            case GQL.IProductKey.Deb:
                return true;
        }
        return false;
    };
    static getPaymentDataFromRepresentationRecord(paymentAmount, paymentRepresentationRecordProductKey, paymentSourceRecordProductKey, paymentRepresentationRecord, paymentRepresentationRecordItems) {
        if (!this.isProductPaymentRepresentation(paymentRepresentationRecordProductKey)) {
            throw new Error(`invalid paymentRepresentationRecordProductKey: ${paymentRepresentationRecordProductKey}`);
        }
        if (!this.isProductPaymentSource(paymentSourceRecordProductKey)) {
            throw new Error(`invalid paymentSourceRecordProductKey: ${paymentSourceRecordProductKey}`);
        }
        const paymentBrutto = SollHaben.areSameSign(paymentRepresentationRecordProductKey, paymentSourceRecordProductKey)
            ? paymentAmount
            : -paymentAmount;
        const getKontoNum = (num) => KontoNumUtils.getExtNum(num, CompanyKontoExtMax, KontoDefaultLen.Category);
        const recordCategoryNum = paymentRepresentationRecord.category;
        if ([GQL.IProductKey.Kb, GQL.IProductKey.Bank].includes(paymentRepresentationRecordProductKey)) {
            if (!recordCategoryNum) {
                throw new Error(`payment representation record Kb/Bank MUST have recordCategory`);
            }
            const typeMap = new Map([
                [GQL.IProductKey.Kb, GQL.IPaymentType.Kasse],
                [GQL.IProductKey.Bank, GQL.IPaymentType.Bank],
            ]);
            return {
                amount: paymentBrutto,
                konto: getKontoNum(recordCategoryNum),
                type: typeMap.get(paymentRepresentationRecordProductKey),
            };
        }
        if ([GQL.IProductKey.Fe].includes(paymentRepresentationRecordProductKey)) {
            const categoryNumValues = new Set(paymentRepresentationRecordItems.map(v => v.category));
            if (categoryNumValues.size !== 1) {
                throw new Error(`error calculating payment amount for FE representation record: items have exactly one value in the list of categories: ${[
                    ...categoryNumValues,
                ].toString()} `);
            }
            const itemCategoryNum = [...categoryNumValues][0];
            const isFeRecordInverted = Boolean(itemCategoryNum) && !recordCategoryNum;
            return isFeRecordInverted
                ? { amount: -paymentBrutto, konto: getKontoNum(itemCategoryNum), type: GQL.IPaymentType.Fe }
                : { amount: paymentBrutto, konto: getKontoNum(recordCategoryNum), type: GQL.IPaymentType.Fe };
        }
        throw new Error(`unhandled paymentRepresentationRecordProductKey: ${paymentRepresentationRecordProductKey}`);
    }
}
//# sourceMappingURL=PaymentUtils.js.map